import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import $ from 'jquery';
import config from '../config.json'
import { gridLayer } from 'leaflet';
import { Grid, row, Dropdown } from 'semantic-ui-react';
import { Checkbox } from '@blueprintjs/core';

/**
 * Please note that due to issues with having multiple sources of truth, this component only uses the photos prop. Attempts to create convenient state variables 
 * result in unexpected behavior. Unfortunatly using the photos prop throughout this component has made it very ugly
 * https://en.wikipedia.org/wiki/Single_source_of_truth
 */
export default class ImageGallery extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // Current slide refers to the index in the entire photos list
            currentSlide: 0,
            // CurrentSlideFiltered refers to the index in the filtered list of photos based on activity type
            currentSlideFiltered: 0,
            selectedActivity: "All",
            selectedActivityID: -1,
            activityOptions: [
                { key: '-1', value: -1, text: 'All' },
                { key: '0', value: 0, text: 'NA' },
                { key: '1', value: 1, text: 'Snow & Ice Control' },
                { key: '2', value: 2, text: 'Gravel Maintenance' },
                { key: '3', value: 3, text: 'Inspection' },
            ]
        }
        //Binds methods for semantic UI to the components this. Otherwise it cannot access props
        this.updateFilter = this.updateFilter.bind(this)
        this.archiveStateChange = this.archiveStateChange.bind(this)

    }

    /**
     * Updates the activityID state if the filter is valid
     * @param {*} event event fired by the semanticUI dropdown
     * @param {*} param1 the value (activityID) from the selected element in the dropdown
     */
    updateFilter = (event, { value }) => {
        var filtered = this.props.photos
        if (value > -1) {
            // If the filter value isn't all, filter the list
            var filtered = filtered.filter((photo) =>
                photo.activity === value
            )
        }
        if (filtered.length === 0) {
            alert("There are no photos of that activity type for this VRIC Point")
        }
        else {
            // Get the index in the photos list of the first occurance of the given activity type 
            var nextIndex = this.props.photos.map((photo) => photo.ID).indexOf(filtered[0].ID)
            this.setState({ currentSlide: nextIndex, currentSlideFiltered: 0, selectedActivity: event.target.innerText, selectedActivityID: value })
        }

    }

    render() {
        return (
            <div>
                <Grid style={{ margin: 1 }} columns={2}>
                    <Grid.Row style={{ padding: 1 }}>
                        <Grid.Column >
                            <Dropdown placeholder='Select Activity'
                                fluid
                                search
                                selection
                                options={this.state.activityOptions}
                                onChange={this.updateFilter}>
                            </Dropdown>
                        </Grid.Column>
                        <Grid.Column>
                            Activity: {this.state.selectedActivity}
                        </Grid.Column>

                    </Grid.Row>
                    <Grid.Row>
                        <img src={this.props.photos[this.state.currentSlide]['FilePath']} width="300"></img>
                    </Grid.Row>
                    <Grid.Row>
                        <p>{(this.props.photos[this.state.currentSlide]['CollectionDateTime'].toString())}</p>
                    </Grid.Row>
                    <Grid.Row>
                        <Button onClick={() => this.previous()}>Previous</Button>
                        <Button onClick={() => this.next()} >Next</Button>
                        <Button onClick={() => this.delete()} color='red'>Delete</Button>
                        {/* A very ugly photo index counter. If -1 is selected, it shows the length of the photo list, otherwise it shows how many of each activity */}
                        {this.state.currentSlideFiltered + 1} / {this.props.photos.filter((photo) => photo.activity === this.state.selectedActivityID).length > 0 ?
                            this.props.photos.filter((photo) => photo.activity === this.state.selectedActivityID).length :
                            this.props.photos.length}
                    </Grid.Row>
                    <Grid.Row>
                        <Checkbox label='Archive Photo'
                            onChange={this.archiveStateChange}
                            checked={this.props.photos[this.state.currentSlide].isArchived}></Checkbox>
                    </Grid.Row>
                    <Grid.Row>
                        <p>Please note that all unarchived photos will be deleted after one year</p>
                    </Grid.Row>
                </Grid>
            </div>
        );

    }
    /**
     * Also a very ugly method. Creates a temporary copy of filteredPhotos, shows then sets the index to the next of it's activity type in the props
     * photo list
     */
    previous() {

        var filteredPhotos = [...this.props.photos]
        if (this.state.selectedActivityID > -1) {
            // Filter the photos if the activity type isn't all
            var filteredPhotos = this.props.photos.filter((photo) => photo.activity === this.state.selectedActivityID)
        }
        // Get the index of the current photo in the filtered list, then subtract one from it
        var filteredListIndex = filteredPhotos.map((photo) => photo.ID).indexOf(this.props.photos[this.state.currentSlide].ID)
        var nextInd = filteredListIndex - 1;
        if (nextInd > -1) {
            // If it's a valid index, use it to find the index in the photos list of the next activity of a given type
            var nextIndex = this.props.photos.map((photo) => photo.ID).indexOf(filteredPhotos[nextInd].ID)
            this.setState({ currentSlide: nextIndex, currentSlideFiltered: nextInd })
        } else {
            // Wrap around to the last photo in the filtered list
            var nextIndex = this.props.photos.map((photo) => photo.ID).indexOf(filteredPhotos[filteredPhotos.length - 1].ID)
            this.setState({ currentSlide: nextIndex, currentSlideFiltered: filteredPhotos.length - 1 })
        }
    }

    next() {
        var filteredPhotos = [...this.props.photos]
        if (this.state.selectedActivityID > -1) {
            // Filter the list if it isn't all activities
            var filteredPhotos = this.props.photos.filter((photo) => photo.activity === this.state.selectedActivityID)
        }
        // Find the current index of the current photo in the filtered list, then add one to find the next index
        var filteredListIndex = filteredPhotos.map((photo) => photo.ID).indexOf(this.props.photos[this.state.currentSlide].ID)
        var nextInd = filteredListIndex + 1;
        if (nextInd < filteredPhotos.length) {
            // If it is a valid index, use it to find the index in the photos list of the next photo of the given activity type
            var nextIndex = this.props.photos.map((photo) => photo.ID).indexOf(filteredPhotos[nextInd].ID)
            this.setState({ currentSlide: nextIndex, currentSlideFiltered: nextInd })
        } else {
            // Otherwise wrap around to the first photo in the filtered list
            var nextIndex = this.props.photos.map((photo) => photo.ID).indexOf(filteredPhotos[0].ID)
            this.setState({ currentSlide: nextIndex, currentSlideFiltered: 0 })
        }
    }

    archiveStateChange() {
        // These lines update the current photos activity bool in the photos list. Quite dumb  
        // https://stackoverflow.com/questions/29537299/react-how-to-update-state-item1-in-state-using-setstates
        var photoList = [...this.props.photos]
        var index = this.props.photos.map((photo) => photo.ID).indexOf(this.props.photos[this.state.currentSlide].ID)
        var currentPhotoCopy = { ...photoList[index] }
        currentPhotoCopy.isArchived = !currentPhotoCopy.isArchived
        photoList[index] = currentPhotoCopy;

        // Update in the DB and the photos list respectively. Convert bool to bit
        this.updatePhotoState(currentPhotoCopy.ID, currentPhotoCopy.isArchived ? 1 : 0)
        this.props.UpdateVRICPhotos(photoList)
    }

    /**
     * posts to the server the new archived state of a photo
     * @param {int} id 
     * @param {bit} state 
     */
    updatePhotoState(id, state) {
        $.ajax({
            type: 'POST',
            url: `${config.server}\\updateVRICPhotoArchivedState\\${id}\\${state}`,
            contentType: 'application/json',
            success: (data) => {
                // Remove deleted photo from the local list
                console.log("Photo archive state updated")
            },
            error: (data) => {
                console.log("Fail")
            }
        });
    }

    /**
     * Deletes a photo from the photo webserver and DB
     */
    delete() {
        if (window.confirm("Do you want to delete this photo?")) {
            //get the filename only
            var photoToDelete = this.props.photos[this.state.currentSlide]
            var bits = photoToDelete.FilePath.split('/')
            var fileName = bits[bits.length - 1].replace('\"', '')

            var newestDateForActivityType = this.props.photos.filter((photo) => photo.activity === photoToDelete.activity).map((photo) => photo.CollectionDateTime).sort((a, b) => b - a)[0]

            // Only allow deletion if it isn't the newest photo in it's activity and it's not archived
            if (!(photoToDelete.CollectionDateTime === newestDateForActivityType || photoToDelete.isArchived)) {
                //Delete the photo from the webserver. If you update the PHP script, please update it in the DeleteVRICPhotos Project
                $.ajax({
                    type: 'POST',
                    data: {
                        'filename': fileName,
                        'username': 'deletePhotosUser',
                        'password': 'ugptiVRICPhotoDeletePlease'
                    },
                    url: `https://dotsc.ugpti.ndsu.nodak.edu/VRIC/deletePhoto.php`,
                    dataType: 'json',
                    complete: (data) => {
                        //Delete the photo from the DB
                        var id = this.props.photos[this.state.currentSlide]['ID']
                        $.ajax({
                            type: 'POST',
                            url: `${config.server}\\deleteVRICPhoto\\${id}`,
                            contentType: 'application/json',
                            success: (data) => {
                                // Remove deleted photo from the local list
                                var newList = this.props.photos.slice()
                                newList.splice(this.state.currentSlide, 1)

                                //Set index to next of filtered activity
                                this.next()

                                // Update prop list. Also in map-googlemap
                                this.props.UpdateVRICPhotos(newList, false)
                                alert("Photo Deleted")

                            },
                        });
                    }
                });
            } else {
                alert("You cannot delete this photo because it's the most recent photo in it's activity type or because it is archived.")
            }

        }
    }
    componentDidMount() {
    }
}


// WEBPACK FOOTER //
// ./src/layers/image-gallery.js